import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Badge } from '@aimsos/ui';

/** The numbered steps of a workflow's journey or of a suggestion (CT-5713). */
const NextBestActionStepList = memo(function NextBestActionStepList({ steps }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <ol className="flex flex-col gap-3">
      {steps.map((step, index) => (
        <li key={step.id} className="flex gap-3 text-sm">
          <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-surface-muted text-xs font-semibold text-content">
            {index + 1}
          </span>
          <div className="flex min-w-0 flex-col gap-1">
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-medium text-content">{step.title}</span>
              {step.startsNow ? (
                <Badge variant="purple" size="small">
                  {t('profile.nba.startsNow')}
                </Badge>
              ) : null}
            </div>
            {step.description ? <p className="text-content-secondary">{step.description}</p> : null}
          </div>
        </li>
      ))}
    </ol>
  );
});

export default NextBestActionStepList;
